export class GameFlowModuleEvents {
    public static readonly START_RANDOM_WILD_FEATURE: symbol = Symbol('START_RANDOM_WILD_FEATURE');
    public static readonly START_COIN_FLIGHT_FEATURE: symbol = Symbol('START_COIN_FLIGHT_FEATURE');
    public static readonly START_WHEEL_BONUS: symbol = Symbol('START_WHEEL_BONUS');
}
